var _circle, _circle2, _circle3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 354,
    viewBox: "0 0 354 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3066_1627)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 176.25,
    cy: 173.196,
    r: 134.054,
    transform: "rotate(-120 176.25 173.196)",
    stroke: "url(#paint0_linear_3066_1627)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.286,
    cy: 172.296,
    r: 158.833,
    transform: "rotate(90 177.286 172.296)",
    stroke: "url(#paint1_linear_3066_1627)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.014 61.6639C118.171 73.271 112.938 86.8584 101.331 92.0145C89.7296 97.1706 76.1419 91.9383 70.9857 80.3254C65.8296 68.7243 71.0619 55.1368 82.6633 49.9866C94.2705 44.8305 107.858 50.0569 113.009 61.6639H113.014Z",
    fill: "url(#paint2_radial_3066_1627)"
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 173.5,
    r: 133.5,
    fill: "url(#paint3_radial_3066_1627)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.05 241.535C330.516 247.086 328.014 253.584 322.463 256.05C316.914 258.516 310.416 256.014 307.95 250.46C305.484 244.912 307.986 238.413 313.535 235.95C319.086 233.484 325.584 235.984 328.048 241.535H328.05Z",
    fill: "url(#paint4_radial_3066_1627)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.223 309.347C113.241 313.889 111.193 319.205 106.651 321.223C102.112 323.241 96.7947 321.193 94.777 316.649C92.7594 312.109 94.8068 306.793 99.3465 304.777C103.888 302.76 109.205 304.805 111.221 309.347H111.223Z",
    fill: "url(#paint5_radial_3066_1627)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3066_1627",
    x1: 176.25,
    y1: 38.642,
    x2: 176.25,
    y2: 307.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3066_1627",
    x1: 42.42,
    y1: 252.963,
    x2: 336.961,
    y2: 170.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3066_1627",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.3171 70.97) rotate(-23.9496) scale(22.9918 22.9915)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0.442748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3066_1627",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(298.096 247.053) rotate(-145.739) scale(106.485)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B6CEE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3066_1627",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(318.152 245.986) rotate(-23.9496) scale(10.9961 10.9959)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0.442748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3066_1627",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.124 312.988) rotate(-23.9496) scale(8.99678 8.99668)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0.442748
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3066_1627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 354,
    height: 354,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDefault);
export default __webpack_public_path__ + "static/media/Circle_default.22586877ee327129b97fc24d4d61ae21.svg";
export { ForwardRef as ReactComponent };